import React from 'react'

import { LabelProps, Label } from '@rebass/forms'

type Props = LabelProps

const SInputLabel = React.forwardRef((props: Props, ref) => {
    const { sx = {}, ...otherProps } = props

    return (
        <Label
            sx={{
                textAlignLast: 'left',
                whiteSpace: 'pre-line',
                lineHeight: '140%',
                fontWeight: '700',
                fontSize: '14px',
                opacity: '87%',
                ...props.sx,
            }}
            ref={ref}
            {...otherProps}
        />
    )
})

SInputLabel.displayName = 'SInputLabel'

export default SInputLabel
